import React, { createContext, useContext, useEffect, ReactNode } from "react";
import Auth from "@xometry/auth-context";
import Logger from "../logger";
import { UserValidationContext } from "./user-validation-context";

interface CoralogixContextType {
  isInitialized: boolean;
}

const CoralogixContext = createContext<CoralogixContextType>({
  isInitialized: false,
});

interface CoralogixProviderProps {
  children: ReactNode;
}

export const CoralogixProvider: React.FC<CoralogixProviderProps> = ({
  children,
}) => {
  const [isInitialized, setIsInitialized] = React.useState(false);
  const userValidation = useContext(UserValidationContext);

  useEffect(() => {
    setIsInitialized(true);

    if (userValidation.isReady && userValidation.userData) {
      Logger.setUserContext({
        id: userValidation.userData.id,
        emailAddress: userValidation.userData.emailAddress,
        firstName: userValidation.userData.firstName,
        lastName: userValidation.userData.lastName,
      });
    }
  }, [userValidation]);

  const contextValue = {
    isInitialized,
  };

  return (
    <CoralogixContext.Provider value={contextValue}>
      {children}
    </CoralogixContext.Provider>
  );
};

export const useCoralogix = (): CoralogixContextType => {
  const context = useContext(CoralogixContext);
  if (!context) {
    throw new Error("useCoralogix must be used within a CoralogixProvider");
  }
  return context;
};

export default CoralogixContext;
